import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface ConfirmStagedBookingPayloadTypes {
  bookingNumber: string
  travelerId: number | null
  newCard: boolean
  paymentType: string
}

export interface ConfirmStagedBookingRequest
  extends Partial<AxiosRequestConfig> {
  params: ConfirmStagedBookingPayloadTypes
}

export interface ConfirmStagedBookingResponseData {
  isFirstLogin: boolean
  message?: string
  errorCode?: string
  status: number
  bookingNo?: string
  bookingId?: number
  bookingTotalAmount?: number
  paymentMethod?: string
}

export interface ConfirmStagedBookingResponse extends AxiosResponse {
  data: ConfirmStagedBookingResponseData
}

export function confirmStagedBookingApi(
  { params }: ConfirmStagedBookingRequest,
  axiosInstance: AxiosInstance,
): Promise<ConfirmStagedBookingResponse> {
  const url = `/booking/confirm-staged-booking-payment`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<ConfirmStagedBookingResponse>
}
